import React from 'react'
import { NavLink } from 'react-router-dom'
import { Nav, Navbar, NavItem } from 'react-bootstrap'
import ExternalButton from 'components/ExternalButton'
import LinkButton from 'components/LinkButton'
import logo from 'images/apruvd-logo.png'

function PageHeader() {
    return (
        <header id="top" className="header">
            <Navbar color="dark" fixed="top">
                <Navbar.Brand href="/"><img className="logo" src={logo} alt="Apruvd - See the good" /></Navbar.Brand>
                <Nav className="menu">
                    <NavItem>
                        <NavLink to="/">Home</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/about">About</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/services">Services</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/ai">AI<svg className="ai-sparkle" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 0 L14.2 9.8 L24 12 L14.2 14.2 L12 24 L9.8 14.2 L0 12 L9.8 9.8 Z" /></svg></NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/customers">Customers</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/plans">Plans</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/contact">Contact</NavLink>
                    </NavItem>
                </Nav>
                <div className="nav-buttons">
                    <ExternalButton to="https://app.apruvd.com">Login</ExternalButton>
                    <LinkButton to="/contact">Let's Talk!</LinkButton>
                </div>
            </Navbar>
        </header>
    )
}

export default PageHeader
